module.exports = __webpack_public_path__ + "static/2-insights-b15a63e5d8748bf8e1fcea933d984a56.jpg";